module.exports = __webpack_public_path__ + "static/media/12_plantilla_qr_comida_2.d4160ed8.png";